export default __webpack_public_path__ + "static/media/dubai-multi-commodities-center.322cd40e.png";